import { ShieldCheck, TrendingUp, MapPin, LayoutGrid, CalendarCheck, Headphones } from "lucide-react";
import { SectionHeading, Reveal } from "@/components/Reveal";

const REASONS = [
  { icon: ShieldCheck, title: "Transparent Information", text: "Clear property details and straightforward communication." },
  { icon: TrendingUp, title: "Investment-Focused Approach", text: "Properties presented with long-term investment considerations in mind." },
  { icon: MapPin, title: "Strategic Locations", text: "Focus on well-connected areas around Nagpur." },
  { icon: LayoutGrid, title: "Multiple Property Options", text: "Residential, commercial and investment opportunities." },
  { icon: CalendarCheck, title: "Site Visit Assistance", text: "Help customers arrange property visits." },
  { icon: Headphones, title: "Customer Support", text: "Easy enquiry and communication process." },
];

export default function WhyChooseUs() {
  return (
    <section id="why-choose" data-testid="why-choose-section" className="py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          chapter="05"
          eyebrow="The Difference"
          title="Why Choose Us"
          description="A straightforward, service-first way to explore plot opportunities around Nagpur."
        />
        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {REASONS.map((r, i) => (
            <Reveal key={r.title} delay={i * 0.06}>
              <div className="group h-full rounded-xl border border-gray-100 bg-white p-8 shadow-[0_8px_30px_rgb(0,0,0,0.04)] transition-colors duration-300 hover:border-gold/50">
                <r.icon className="h-7 w-7 text-gold-dark transition-colors duration-300 group-hover:text-gold" aria-hidden="true" />
                <h3 className="mt-5 font-display text-lg font-semibold text-navy">{r.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{r.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
